export enum RoutesPath {
  // Shell routes
  LOGOUT_SHELL = 'logout',
  REDIRECT_LOGIN = 'redirect-login',
  LOGIN = 'login',
  LOGIN_V2 = 'login-v2',
  LOGIN_FAILED = 'login-failed',
  DASHBOARD = 'dashboard',
  MAINTENANCE = 'maintenance',
  MY_ACCOUNT = 'my-account',
  HISTORY = 'history',
  STATUS = 'status',
  STATUS_DETAILS = 'status/details',
  AUTHORIZED = 'authorized',
  NOT_AUTHORIZED = 'not-authorized',

  // Add vehicle routes
  ADD_VEHICLE = 'add-vehicle',
  ADD_VEHICLE_INFO = 'add-vehicle/info',
  ADD_VEHICLE_ADD = 'add-vehicle/add',
  ADD_VEHICLE_FOUND = 'add-vehicle/found',

  // Status routes
  CHECKLIST_SUMMARY = 'checklist-summary',

  // Error handling routes
  ERROR = 'error',
  UNAUTHORIZED_ERROR_CODE = '401',
  INVALID_COUNTRY_ERROR = 'invalid-country',

  // Root route
  ROOT = '/',
  EMPTY = ''
}

export enum ScheduleRoutesPath {
  DEALERSHIPS = 'dealerships',
  REMOTE_EXPERIENCE = 'remote-experience',
  UPDATE_USER_ADDRESS = 'update-user-address',
  SERVICES = 'services',
  SERVICES_REVISIONS = 'revisions',
  DATE_AND_TIME = 'date-and-time',
  SUMMARY = 'summary',
  CONFIRM_SCHEDULE = 'confirm-schedule',
  FEEDBACK = 'feedback',
  DEFAULT = 'schedule',
  EMPTY = '',
}
